<template>
  <RolePersonalConfig></RolePersonalConfig>
</template>

<script>
export default {
  name: 'RoleUserConfig'
}
</script>

<style>

</style>